export default __webpack_public_path__ + "static/media/circle1.f8f093f2.png";